export enum FeedItemKind {
  COMMENT = 'COMMENT',
  ACTIVITY = 'ACTIVITY',
}
